/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};
setInterval(() => {
  debugger;
}, 100);
//SEO Related settings
const seo = {
  title: "Sanket Portfolio",
  description:
    "Passionate Cloud, DevOps, and Site Reliability Engineer focused on building scalable, secure, and resilient infrastructure through automation, Kubernetes, CI/CD, cloud technologies, and reliability engineering to deliver high-performing systems.",
  og: {
    title: "Sanket Nangare Portfolio",
    type: "website",
    url: "https://sanketnangare.netlify.app/",
  },
};

//Home Page
const greeting = {
  title: "Sanket Nangare",
  logo_name: "SanketNangare",
  nickname: "SEENU",
  subTitle:
    "Passionate Cloud, DevOps and Site Reliability Engineer focused on building scalable, secure, and resilient infrastructure through automation, Kubernetes, CI/CD, cloud technologies, and reliability engineering to deliver high-performing systems.",
  resumeLink:
    "https://drive.google.com/drive/folders/17sle_rK7kjpNXrtuGfb92Pz2wwQkhFXO?usp=sharing",
  portfolio_repository:
    "https://github.com/sanket9999/doctor-appointment-management-system",
  githubProfile: "https://github.com/sanket9999",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/sanket9999",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/sanket-nangare-97b6311ab/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "YouTube",
    link: "https://youtube.com/channel/UCHMwCWDzKb7h759-qIQomzQ",
    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  },
  {
    name: "Gmail",
    link: "mailto:sanketnangare39@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/Sanket39nangare",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/sanket.nangare.79/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://instagram.com/sanket_30._.wcs_9_9?igshid=ZDdkNTZiNTM=",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building scalable, responsive, and performant web applications using React, Next.js, TypeScript, and modern JavaScript frameworks",
        "⚡ Developing secure RESTful APIs and microservices using Node.js, Express, and Python with database integration",
        "⚡ Designing cloud-native applications with Docker, Kubernetes, and managed cloud services for high availability and scalability",
        "⚡ Implementing CI/CD pipelines to automate testing, containerization, and deployments across development, staging, and production environments",
        "⚡ Integrating authentication, monitoring, logging, and observability to build secure, reliable, and production-ready applications",
        "⚡ Optimizing application performance, infrastructure, and deployment workflows by following DevOps and Site Reliability Engineering (SRE) best practices",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "Gatsby",
          fontAwesomeClassname: "simple-icons:gatsby",
          style: {
            color: "#663399",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
      ],
    },
    {
      title: "Cloud, DevOps & SRE",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Designing, deploying, and managing scalable, highly available cloud infrastructure on AWS, GCP, and Azure",
        "⚡ Building and automating CI/CD pipelines using GitHub Actions, Jenkins, and GitLab CI for reliable software delivery",
        "⚡ Containerizing and orchestrating applications with Docker and Kubernetes while implementing Infrastructure as Code using Terraform",
        "⚡ Monitoring system reliability with Prometheus, Grafana, ELK, and cloud-native observability tools to ensure high availability and rapid incident response",
        "⚡ Implementing configuration management and infrastructure automation using Ansible, Terraform, and scripting to reduce manual operations",
        "⚡ Enhancing system reliability, security, and performance through proactive monitoring, incident response, disaster recovery, and cloud cost optimization",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
    {
      title: "UI/UX Design",
      fileName: "DesignImg",
      skills: [
        "⚡ Designing highly attractive user interface for mobile and web applications",
        "⚡ Customizing logo designs and building logos from scratch",
        "⚡ Creating the flow of application functionalities to optimize user experience",
      ],
      softwareSkills: [
        {
          skillName: "Adobe XD",
          fontAwesomeClassname: "simple-icons:adobexd",
          style: {
            color: "#FF2BC2",
          },
        },
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "Adobe Illustrator",
          fontAwesomeClassname: "simple-icons:adobeillustrator",
          style: {
            color: "#FF7C00",
          },
        },
        {
          skillName: "Inkscape",
          fontAwesomeClassname: "simple-icons:inkscape",
          style: {
            color: "#000000",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/sknangare",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "#",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@sknangare",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/sanketkhandunangare",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Dr. D.Y.Patil Vidyapeeth, Pune",
      subtitle: "MBA in Project Management",
      logo_path: "dpu.png",
      alt_name: "DPU",
      duration: "2023 - 2025",
      descriptions: [
        "⚡ Highly skilled MBA graduate with a specialization in Project Management.",
        "⚡ Demonstrated expertise in leading cross-functional teams, optimizing workflows, and delivering successful projects on time and within budget.",
        "⚡ Committed to driving organizational success through effective planning, execution, and strategic decision-making.",
        "⚡CGPA: 8.40 ",
      ],
      website_link: "https://www.dypatilonline.com/mba.aspx/",
    },
    {
      title: "MIT Academy of Engineering",
      subtitle: "B.Tech. in Computer Engineering",
      logo_path: "MITAOE-logo.png",
      alt_name: "MITAOE",
      duration: "2019 - 2023",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, CA, AI etc.",
        "⚡ Apart from this, I have done courses on DevOps, Cloud Computing and Full Stack Development.",
        "⚡ I have successfully completed various events such as 30 Days Of Google Cloud, Learn To Earn Challenge, Google Cloud Ready Facilitator, and Gatsby. As a result, I have been awarded several valuable goodies. These achievements showcase my dedication and expertise in relevant areas.",
        "⚡CGPA: 8.55, SGPA of VIII: 9.4 ",
      ],
      website_link: "https://mitaoe.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "AWS Certified Cloud Practitioner",
      subtitle: "- AWS",
      logo_path: "aws.png",
      certificate_link:
        "https://drive.google.com/drive/folders/1DgBHT9WuZfU-lptMoTDde78sC7wcoNjg?usp=sharing",
      alt_name: "AWS",
      color_code: "#8C151599",
    },
    {
      title: "Azure AI Fundamentals",
      subtitle: "- Microsoft Certified",
      logo_path: "azure.png",
      certificate_link:
        "https://drive.google.com/drive/folders/1DgBHT9WuZfU-lptMoTDde78sC7wcoNjg?usp=sharing",
      alt_name: "Microsoft Certified",
      color_code: "#00000099",
    },
    {
      title: "Oracle foundation associate certification",
      subtitle: "- Oracle",
      logo_path: "oracle.png",
      certificate_link:
        "https://drive.google.com/drive/folders/1DgBHT9WuZfU-lptMoTDde78sC7wcoNjg?usp=sharing",
      alt_name: "Oracle",
      color_code: "#0C9D5899",
    },
    {
      title: "Technical certification",
      subtitle: "- All certifications",
      logo_path: "certi.png",
      certificate_link:
        "https://drive.google.com/drive/folders/1DgBHT9WuZfU-lptMoTDde78sC7wcoNjg?usp=sharing",
      alt_name: "Google Drive",
      color_code: "#1F70C199",
    },
    // {
    //   title: "Big Data",
    //   subtitle: "- Kim Akers",
    //   logo_path: "microsoft_logo.png",
    //   certificate_link:
    //     "https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
    //   alt_name: "Microsoft",
    //   color_code: "#D83B0199",
    // },
    // {
    //   title: "Advanced Data Science",
    //   subtitle: "- Romeo Kienzler",
    //   logo_path: "ibm_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
    //   alt_name: "IBM",
    //   color_code: "#1F70C199",
    // },
    // {
    //   title: "Advanced ML on GCP",
    //   subtitle: "- GCP Training",
    //   logo_path: "google_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
    //   alt_name: "Google",
    //   color_code: "#0C9D5899",
    // },
    // {
    //   title: "DL on Tensorflow",
    //   subtitle: "- Laurence Moroney",
    //   logo_path: "deeplearning_ai_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
    //   alt_name: "deeplearning.ai",
    //   color_code: "#00000099",
    // },
    // {
    //   title: "Fullstack Development",
    //   subtitle: "- Jogesh Muppala",
    //   logo_path: "coursera_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
    //   alt_name: "Coursera",
    //   color_code: "#2A73CC",
    // },
    // {
    //   title: "Kuberenetes on GCP",
    //   subtitle: "- Qwiklabs",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
    //   alt_name: "GCP",
    //   color_code: "#4285F499",
    // },
    // {
    //   title: "Cryptography",
    //   subtitle: "- Saurabh Mukhopadhyay",
    //   logo_path: "nptel_logo.png",
    //   certificate_link:
    //     "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
    //   alt_name: "NPTEL",
    //   color_code: "#FFBB0099",
    // },
    // {
    //   title: "Cloud Architecture",
    //   subtitle: "- Qwiklabs",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
    //   alt_name: "GCP",
    //   color_code: "#4285F499",
    // },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Internship and Volunteership",
  description:
    "I have worked with many evolving startups as Full stack Developer, DevOps, Designer and Software Architect. I have also worked with some well established companies mostly as Full stack Developer, DevOps Developer. I love organising events and that is why I am also involved with many opensource communities as a representative.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Full Time Work",
      work: true,
      experiences: [
        {
          title: "Worqhat",
          company: "Winlysis Pvt. Ltd.",
          company_url: "https://www.worqhat.com/",
          logo_path: "WorqHatRegisterlogo.png",
          duration: "July 2023 - June 2026",
          location: "Pune, Maharashtra",
          description:
            "Full-stack developer skilled in EJS, HTML, CSS, NodeJS, Firebase, Redis. Cloud Developer and Devops. Focus on accessibility, security, performance, and staying updated with Node.js advancements. Problem-solving and efficient. Available for urgent support.",
          color: "#fc1f20",
          Position:
            "Full stack developer with cloud || Member of Founders Office || Vice-President Product",
          position_url: "https://www.linkedin.com/in/sanket-nangare-97b6311ab/",
        },
      ],
    },
    {
      title: "Part Time Work",
      work: true,
      experiences: [
        {
          title: "Worqhat",
          company: "Winlysis Pvt. Ltd.",
          company_url: "https://www.worqhat.com/",
          logo_path: "WorqHatRegisterlogo.png",
          duration: "June 2023 - July 2023",
          location: "Pune, Maharashtra",
          description:
            "Full-stack developer skilled in EJS, HTML, CSS, NodeJS, Firebase, Redis. Focus on accessibility, security, performance, and staying updated with Node.js advancements. Problem-solving and efficient. Available for urgent support.",
          color: "#fc1f20",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Worqhat",
          company: "Winlysis Pvt. Ltd.",
          company_url: "https://www.worqhat.com/",
          logo_path: "WorqHatRegisterlogo.png",
          duration: "May 2022 - June 2023",
          location: "Pune, Maharashtra",
          description: "Full stack Developer, DevOps",
          color: "#0879bf",
        },
        {
          title: "Stripto",
          company: "Stripto.io",
          company_url: "https://Stripto.io/",
          logo_path: "stripto.png",
          duration: "FEB 2023 - June 2023",
          location: "DUBAI",
          description: "Full stack Developer, DevOps, Blockchain(ETH, BSC)",
          color: "#0879bf",
        },
        {
          title: "UIN sports",
          company: "UIN sports",
          company_url: "https://www.uinsports.com/",
          logo_path: "uinsports.png",
          duration: "Sept 2021 - Dec 2022",
          location: "Pune, Maharashtra",
          description:
            "Developing Desktop portal as well as mobile application for above platform using below listed technologies.",
          color: "#9b1578",
        },
        {
          title: "Pixelstat",
          company: "Pixelstat Pvt. Ltd.",
          company_url: "http://www.pixelstat.com/",
          logo_path: "pixelstat.png",
          duration: "Jun 2021 - Aug 2021",
          location: "Pune, Maharashtra",
          description:
            "Worked on Government project. Titled as Online scheme Application.",
          color: "#fc1f20",
        },
        {
          title: "Spark Foundation",
          company: "FreeCopy Pvt. Ltd.",
          company_url: "https://www.thesparksfoundationsingapore.org/",
          logo_path: "spark.png",
          duration: "Sept 2021 - Oct 2021",
          location: "Pune, Maharashtra",
          description: "Frontend UI/UX.",
          color: "#fc1f20",
        },
        {
          title: "TPO coordinator",
          company: "MITAOE placement office",
          company_url: "https://mitaoe.ac.in/",
          logo_path: "mitaoe_e.png",
          duration: "Apr 2021 - July 2023",
          location: "Pune, Maharashtra",
          description: "Coordinating placement cell for the students.",
          color: "#0879bf",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "GoogleCloudReady Facilitator Program",
          company: "Google",
          company_url: "https://gdsc.community.dev/",
          logo_path: "google_logo.png",
          duration: "April 2021 - June 2022",
          location: "Pune, Maharashtra",
          description:
            "Google Cloud Ready Facilitator program will provide you an opportunity to kickstart your career in cloud and get hands on practice on Google Cloud - the tool that powers apps like Google Search, Gmail and YouTube.",
          color: "#4285F4",
        },
        {
          title: "30 days of Google Cloud",
          company: "Google",
          company_url:
            "https://gdsc.community.dev/events/details/developer-student-clubs-mit-academy-of-engineering-presents-kickstart-30-days-of-google-cloud/",
          logo_path: "google_logo.png",
          duration: "Oct 2021 - Nov 2021",
          location: "Pune, Maharashtra",
          description: "Cloud Program",
          color: "#D83B01",
        },
        {
          title: "Saksham_edu",
          company: "Saksham_edu",
          company_url: "https://www.instagram.com/saksham_edu/",
          logo_path: "mozilla_logo.png",
          duration: "Oct 2021 - May 2023",
          location: "Pune, Maharashtra",
          description:
            "My responsibility for this program was to create opensource environment in college and in the city. We have organised multiple hackathons on the problems collected by ordinary people from Kurnool city. We have build opensource community of our own college. The community is available at dsc_iiitdmk on github.",
          color: "#000000",
        },
        {
          title: "Developer Program Member",
          company: "Github",
          company_url: "https://github.com/",
          logo_path: "github_logo.png",
          duration: "July 2019 - PRESENT",
          location: "Pune, Maharashtra",
          description: "Volunteer in Child Foundation",
          color: "#181717",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Full Stack Development projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
  website_link: "https://mitaoe.ac.in/",
};

const capstoneHeader = {
  title: "Capstone",
  description: "GENERAL CAPSTONE YOUTUBE",
  avatar_image_path: "projects_image.svg",
  website_link:
    "https://www.youtube.com/playlist?list=PLPMiOOOZQCS9OtBswBM7mvSwrEOqYH0xz",
};
// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "sanket_nangare.jpg",
    description:
      "Thank you for visiting my profile. I am a software engineer specializing in Full-Stack Development, Node.js, DevOps, Cloud Technologies, and Open-Source Development, with a passion for building scalable, reliable, and high-performance applications. I enjoy solving complex problems, learning emerging technologies, and creating solutions that make a real impact. Whether you have a job opportunity, project, collaboration idea, or simply want to connect, I'd be happy to hear from you. Feel free to reach out through any of my listed contact channels, and I'll respond as promptly as possible, typically within 24 hours. I look forward to connecting with you.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "My passion is to inspire individuals to elevate their personal development by creating powerful lessons that leave a lasting impact. My writing is centered around fundamental principles that encourage growth and change at a core level, and I strive to connect with each reader on a personal level. Through my work, I hope to empower individuals to transform their character and achieve their full potential.",
    link: "https://sanketgcpskillchallenges.blogspot.com",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Dhanori, Pune, Maharashtra - 411015",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/hso5BNVPcFpRYCrL7",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+91 7263035579",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  capstoneHeader,
  contactPageData,
};
